module.exports = shared.MarkerClustererPlus;